export const debug = {
  participantStripFullMixPreview: true,
}
